import { StatsigClient } from '@statsig/js-client'

import { IS_PENTEST, IS_PROD, IS_STAGING, STATSIG_CLIENT_KEY } from '~config'

// Keep in sync with DEVICE_ID_KEY in backend/core/utils/statsig_utils.py.
export const DEVICE_ID_KEY = 'Device ID'

export const statsigClient: StatsigClient | null = STATSIG_CLIENT_KEY
  ? new StatsigClient(
      STATSIG_CLIENT_KEY,
      { userID: 'anonymous' },
      {
        environment: {
          tier: IS_PROD ? 'production' : IS_STAGING || IS_PENTEST ? 'staging' : 'development',
        },
      },
    )
  : null
